<script setup lang="ts">
const GAP = "gap-4 md:gap-4 lg:gap-6 xl:gap-8"
const PADDING = "p-3 md:p-4 lg:p-6 xl:p-8"
const ROUNDED = "md:rounded"
defineProps<{ as?: string }>()
</script>

<template>
  <component
    :is="as || 'div'"
    class="flex flex-col scroll-pt-[60px] bg-white md:shadow-lg mx-auto max-w-[1200px]"
    :class="[GAP, PADDING, ROUNDED]"
  >
    <div class="rounded-t-[inherit] overflow-hidden BLayoutPage__negate-padding" v-if="$slots.intro">
      <slot name="intro"></slot>
    </div>
    <slot></slot>
  </component>
</template>

<style>
.BLayoutPage__negate-padding {
  @apply -m-3 md:-m-4 lg:-m-6 xl:-m-8 !mb-0;
}
</style>
